import { defineMessages } from 'react-intl';

const messages = defineMessages({
  modalEntriesTitle: {
    id: 'modalEntriesTitle',
    defaultMessage: 'Opgeslagen configuraties',
  },
});

export default messages;